<template>
  <v-container fluid>
    <component :is="($store.state.auth.user.settings.dashboard || 'default')" />
  </v-container>
</template>

<script>
  export default {
    components: {
      Default: () => import('@/components/dashboard/MainView'),
    },
  }
</script>
